// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"TextBlock_textBlock__hRx2s","texts":"TextBlock_texts__3VXx4","textItem":"TextBlock_textItem__ptcuQ"};